export default __webpack_public_path__ + "images/onis-high-flag.svg";